import { render, staticRenderFns } from "./DownloadAppPopup.vue?vue&type=template&id=542cb7ed&"
import script from "./DownloadAppPopup.vue?vue&type=script&lang=js&"
export * from "./DownloadAppPopup.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAppPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports